import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { FotaApiService } from '../CommonController/fota-api-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fota-batch-page',
  templateUrl: './fota-batch-page.component.html',
  styleUrls: ['./fota-batch-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    DatePipe,
    NgxPaginationModule,
    MatTooltip,
  ],
})
export class FotaBatchPageComponent implements OnInit {
  uid = '';
  serverName = environment.projectName;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  listOfBatch = [];
  batchList = [];

  deviceFOTAForm: FormGroup;

  userPermissions = [];
  deleteFota = true;
  viewFota = true;
  createFota = true;
  updateFota = true;
  searchField = '';

  constructor(
    private fotaApiService: FotaApiService,
    public router: Router,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe,
    public commonApiService: CommonApiService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.getFotaList(this.searchField);
  }

  checkPermission() {
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.userPermissions.forEach((element) => {
      if (element.pageName === 'Fota' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Fota' && element.create === false) {
        this.createFota = false;
      }
      if (element.pageName === 'Fota' && element.update === false) {
        this.updateFota = false;
      }
      if (element.pageName === 'Fota' && element.delete === false) {
        this.deleteFota = false;
      }
    });
  }

  getFotaList(searchField): void {
    this.spinner.show();
    this.listOfBatch = [];
    this.fotaApiService
      .getFotaList(this.currentPage, this.pageSize, searchField)
      .subscribe({
        next: (res) => {
          if (res.status) {
            this.listOfBatch = res.data;
            this.totalItems = res.totalItems;
            this.commonApiService.openSnackbar(res.message);
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.listOfBatch = [];
          this.commonApiService.openSnackbar(
            err.error.message || 'An error occurred while processing the data.'
          );
          this.spinner.hide();
        },
      });
  }

  onPageChange(event) {
    this.currentPage = event;
    this.getFotaList(this.searchField);
  }

  onSizeChange(newSize): void {
    this.pageSize = newSize;
    this.currentPage = 1; // Reset to the first currentPage
    this.getFotaList(this.searchField);
  }

  onKeyUpEventBatchList(event) {
    this.currentPage = 1;
    this.searchField = event;
    this.getFotaList(this.searchField);
  }

  view(e) {
    sessionStorage.setItem('fotaBatchREFID', e);
    this.redirect('/device-fota');
  }

  deleteBatch(id) {
    if (confirm('Are you sure to Delete')) {
      this.spinner.show();
      this.fotaApiService.deleteBatch(id).subscribe({
        next: (res) => {
          try {
            if (res.status) {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          } catch (error) {
            this.spinner.hide();
            this.commonApiService.openSnackbar(
              error.error.message ||
                'An error occurred while processing the data.'
            );
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(err.error.message);
        },
        complete: () => {
          this.getFotaList('');
          this.spinner.hide();
        },
      });
    }
  }

  exportToExcel(id): void {
    if (confirm('Are You Sure?')) {
      this.spinner.show();
      this.fotaApiService.exportfotaBatch(id).subscribe({
        next: (res) => {
          try {
            if (res.status) {
              const data = res.data;
              this.exportToFile(data.fotaBatchDetails, data.batchDeviceDetail);
            }
          } catch (error) {
            this.commonApiService.openSnackbar(
              error.error.message ||
                'An error occurred while processing the data.'
            );
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(err.error.message);
        },
      });
    }
  }

  private exportToFile(fotaBatchDetails, deviceDta) {
    this.batchList = [];

    deviceDta.forEach((element) => {
      let row: any = {};

      // ───────────────── LCT-A4G FORMAT ─────────────────
      if (this.serverName === 'LCT-A4G') {
        row = {
          // Batch Details
          BATCH_ID: fotaBatchDetails.batchId,
          BATCH_NAME: fotaBatchDetails.name,
          BATCH_TYPE: fotaBatchDetails.batchType,
          BATCH_TIME: fotaBatchDetails.createdAt,
          BATCH_DESC: fotaBatchDetails.description,
          BATCH_PERCENTAGE: fotaBatchDetails.percentage,
          BATCH_STATUS: fotaBatchDetails.status,

          // Device Details
          IMEI: element['imei'],
          STATE: element['state'],
          FOTA_TYPE: element['fotaType'],

          OPEN_CPU_VERSION: element['openCpuVer'],
          OPEN_CPU_STATUS: element['openCpuStatus'],
          OpenCPU_RETRY_COUNT: element['cpuRetryCount'] ?? '--',

          MCU_VERSION: element['ufw'],
          MCU_STATUS: element['mcuStatus'] ?? element['fotaStatus'],
          MCU_RETRY_COUNT: element['mcuRetryCount'] ?? '--',

          TRIGGER_ORDER: element['triggerOrder'] ?? '--',
          Overall_FOTA_STATUS: element['overallFotaStatus'] ?? '--',

          CREATED_BY: element['createdByName'] ?? '--',
        };
      }

      // ───────────────── OTHER SERVER FORMAT ─────────────────
      else {
        row = {
          // Batch Details
          BATCH_ID: fotaBatchDetails.batchId,
          BATCH_NAME: fotaBatchDetails.name,
          BATCH_TYPE: fotaBatchDetails.batchType,
          BATCH_TIME: fotaBatchDetails.createdAt,
          BATCH_DESC: fotaBatchDetails.description,
          BATCH_PERCENTAGE: fotaBatchDetails.percentage,
          BATCH_STATUS: fotaBatchDetails.status,

          // Device Details
          STATE: element['state'],
          FOTA_TYPE: element['fotaType'],
          UIN: element['uin'],
          IMEI: element['imei'],

          CURRENT_FIRMWARE_VERSION: element['af'],
          UPCOMING_FIRMWARE_VERSION: element['ufw'],

          FOTA_STATUS: element['mcuStatus'] ?? element['fotaStatus'],
          FOTA_Percentage: element['fotaPercentage'] ?? '--',
          FOTA_RETRY_COUNT: element['mcuRetryCount'] ?? '--',

          IP_STATUS: element['stateIpStatus'],
          STATE_IP_RESPONSE: element['stateIpRes'] ?? '--',

          Overall_FOTA_STATUS: element['overallFotaStatus'] ?? '--',
          LAST_LOGIN: element['lastlogin'],

          CREATED_BY: element['createdByName'] ?? '--',
        };
      }

      this.batchList.push(row);
    });

    this.commonApiService.createCSVFile(this.batchList, 'Fota_Batch_export');

    this.spinner.hide();
  }

  navigateBack() {
    this.commonApiService.back();
  }

  onRefresh() {
    this.ngOnInit();
  }

  createnew() {
    sessionStorage.setItem('fotaBatchREFID', 'NOID');
    this.redirect('/device-fota');
  }
  redirect(to): void {
    this.router.navigate([to]);
  }

  openManualFotaPage() {
    sessionStorage.setItem('manualfotaimei', '');
    this.router.navigate(['/manual-fota']);
  }
}
